import axios from 'CanExConfig/axios'

export const createRole = async (id, data) => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}/job_experiences`, {
    method: 'POST',
    data: {
      job_role_id: data.role,
      years_experience: data.years_experience,
    },
  })

  return response.data.result
}

export const fetchRoles = async id => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}/job_experiences`, {
    method: 'GET',
  })

  return response.data.result.map(role => ({ ...role }))
}

export const updateRole = async (id, data) => {
  const response = await axios(`/api/candidate/v2/job_experiences/${id}`, {
    method: 'PATCH',
    data: {
      job_role_id: data.role,
      years_experience: data.years_experience,
    },
  })

  return response.data.result
}

export const deleteRole = async id => {
  const response = await axios(`/api/candidate/v2/job_experiences/${id}`, {
    method: 'DELETE',
  })

  return response.data.result
}
